import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction, {
  SpeedDialActionProps,
} from "@mui/material/SpeedDialAction";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { useTheme } from "@mui/styles";
import { getKey } from "core/model/utils/strings";
import { newThemeColors } from "ds_legacy/materials/colors";
import { dp, sizing } from "ds_legacy/materials/metrics";
import { useState } from "react";

export type SpeedDialAction = Pick<
  SpeedDialActionProps,
  "icon" | "tooltipTitle"
> & {
  onClick: () => void;
  testId?: string;
};

type SpeedDialProps = {
  actions: Array<SpeedDialAction>;
  initialState?: boolean;
  testId?: string;
  tooltip: string;
};

export default function SpeedDialInput({
  actions,
  initialState = false,
  testId,
  tooltip,
}: SpeedDialProps) {
  const theme = useTheme();
  const [open, setOpen] = useState(initialState);
  const onClick = () => setOpen(!open);

  return (
    <div style={{ height: open ? undefined : sizing(6) }}>
      <SpeedDial
        ariaLabel={tooltip}
        direction="down"
        FabProps={{
          sx: {
            "&:hover": {
              backgroundColor: theme.palette.secondary.dark,
            },
            backgroundColor: theme.palette.secondary.dark,
            color: newThemeColors.gray[900],
            height: dp(40),
            margin: "8px",
            width: dp(40),
          },
          ...{ "data-testid": testId },
        }}
        icon={<SpeedDialIcon />}
        open={open}
        onClick={onClick}
      >
        {actions.map(({ icon, onClick, testId, tooltipTitle }, index) => (
          <SpeedDialAction
            key={getKey(index)}
            FabProps={{ sx: {}, ...{ "data-testid": testId } }}
            icon={icon}
            sx={{
              "& .MuiSpeedDialAction-staticTooltipLabel": { width: sizing(26) },
            }}
            tooltipOpen
            tooltipTitle={tooltipTitle}
            onClick={() => {
              onClick();
              setOpen(false);
            }}
          />
        ))}
      </SpeedDial>
    </div>
  );
}
